import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Scrollbars from "react-custom-scrollbars";
import { getProfileDetails, getallChats } from "../utilities/ApiCalls";
import { MessageCircle, MessageSquareDiff, View } from "lucide-react";
import axios from "axios";
import Constant from "../Constant";
import { useHistory } from "react-router-dom";
import { NewAuthNav } from "../../Layout/NewAuthNav";
import { useTranslation } from "react-i18next";
import PopoverComponent from "./PopoverComponent";
import { setPageTitle } from "../../utils/titleUtils";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

const Chat = (props) => {
  const location = useLocation();

  useEffect(() => {
    setPageTitle(location.pathname);
  }, [location]);
  const [profile, setProfile] = useState({});
  const [users, setUsers] = useState([]);
  const history = useHistory();
  const [t] = useTranslation();
  const [popoverVisible, setPopoverVisible] = useState(false);

  useEffect(() => {
    getProfile();
  }, []);

  const getProfile = () => {
    getProfileDetails().then((response) => {
      setProfile(response.data.data);
      // console.log("Profile data:", response.data.data);
    });
  };

  const getAllChats = () => {
    getallChats().then((response) => {
      const filteredChats = response.data.filter((chat) => {
        const user = chat.users.find((u) => u._id !== profile._id);
        return user !== undefined; // Filter out chats without a valid other user
      });
      setUsers(filteredChats);
      // console.log("Unfiltered chats are", response.data);
      // console.log("Final chats are", filteredChats);
    });
  };

  useEffect(() => {
    getAllChats();
  }, [profile]);

  const RedirectingFunction = (userId, id, data) => {
    // console.log("UserId:- ", userId);
    // console.log("data:- ", data);
    // console.log("Id:- ", id);
    history.push({
      pathname: `/chat/${userId}/${id}`,
      state: { userId, id, data },
    });
  };

  const togglePopover = () => {
    setPopoverVisible(!popoverVisible);
  };

  const proxiedUrl = (url) => {
    if (!url || url.includes("story-tent-testing.s3.ap-south-1.amazonaws.com")) return url;
    return `${Constant.apiBasePath}proxy-image?url=${encodeURIComponent(url)}`;
  };

  return (
    <div
      style={{
        height: "100vh",
        alignItems: "center",
        display: "flex",
        width: "100%",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <NewAuthNav />
      <div
        style={{
          alignItems: "center",
          height: "100%",
          justifyContent: "center",
          width: "100%",
          marginTop: "-15px",
          display: "flex",
          backgroundColor: "#07262b",
        }}
      >
        <div
          style={{
            alignItems: "center",
            height: "100%",
            maxWidth: "1400px",
            width: "100%",
            backgroundColor: "#07262b",
          }}
        >
          <ChatBoxContainer>
            <ChatBox>
              <ChatContent>
                <Header>
                  {/* <H2>{profile.name}</H2>
                  <Text
                onClick={()=>setOpenTextbox(true)}
                 style={{width:'25px',height:"25px"}}>
                 </Text> */}
                </Header>
                <MessageHeading>
                  {t("Chat.Messages")}
                  <IconButton onClick={togglePopover}>
                    <MessageSquareDiff color="white" />
                  </IconButton>
                  {popoverVisible && (
                    <PopoverComponent
                      visible={popoverVisible}
                      onClose={togglePopover}
                    />
                  )}
                </MessageHeading>
                <MessageHeadingIcon>
                  <MessageCircle></MessageCircle>
                </MessageHeadingIcon>

                {/* Fixed Scrollable Container */}
                <ScrollableContainer>
                  <Scrollbars
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                    renderThumbVertical={() => (
                      <div style={{ display: "none" }} />
                    )}
                    renderTrackVertical={() => (
                      <div style={{ display: "none" }} />
                    )}
                    renderThumbHorizontal={() => (
                      <div style={{ display: "none" }} />
                    )}
                    renderTrackHorizontal={() => (
                      <div style={{ display: "none" }} />
                    )}
                    renderView={(props) => (
                      <div
                        {...props}
                        style={{ ...props.style, overflowX: "hidden" }}
                      />
                    )}
                  >
                    <ChatListContainer>
                      {users.map((data) => {
                        if (data.isGroupChat) {
                          // Render for Group Chats
                          return (
                            <ChatIDS
                              key={data._id}
                              onClick={() =>
                                RedirectingFunction(data._id, data._id, data)
                              }
                            >
                              <img
                                alt="group profile"
                                src={proxiedUrl(data.groupImage)}
                                style={{ borderRadius: "100px" }}
                                width={40}
                                height={40}
                                // crossOrigin="anonymous"
                              />
                              <Name>
                                <h4
                                  style={{
                                    fontFamily: "sans-serif",
                                    fontSize: "12px",
                                    color: "white",
                                    margin: 0,
                                  }}
                                >
                                  {data.chatName}
                                </h4>
                                {data.latestMessage ? (
                                  <span
                                    style={{
                                      marginTop: "4px",
                                      fontSize: "10px",
                                      color: "#ccc",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {data.latestMessage.content}
                                  </span>
                                ) : (
                                  <span
                                    style={{
                                      marginTop: "4px",
                                      fontSize: "10px",
                                      color: "#ccc",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {t("Chat.msg")}
                                  </span>
                                )}
                              </Name>
                            </ChatIDS>
                          );
                        } else {
                          // Render for Direct Messages
                          const user = data.users.find(
                            (u) => u._id !== profile._id
                          ); // Exclude current user's profile
                          if (!user) return null; // Skip if no valid user found
                          return (
                            <ChatIDS
                              key={data._id}
                              onClick={() =>
                                RedirectingFunction(user._id, data._id, data)
                              }
                            >
                              <img
                                alt="profile"
                                src={proxiedUrl(user.profilePic)}
                                style={{ borderRadius: "100px" }}
                                width={40}
                                height={40}
                              />
                              <Name>
                                <h4
                                  style={{
                                    fontFamily: "sans-serif",
                                    fontSize: "12px",
                                    color: "white",
                                    margin: 0,
                                  }}
                                >
                                  {user.name}
                                </h4>
                                {data.latestMessage ? (
                                  <span
                                    style={{
                                      marginTop: "4px",
                                      fontSize: "10px",
                                      color: "#ccc",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {data.latestMessage.content}
                                  </span>
                                ) : (
                                  <span
                                    style={{
                                      marginTop: "4px",
                                      fontSize: "10px",
                                      color: "#ccc",
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                    }}
                                  >
                                    {t("Chat.msg")}
                                  </span>
                                )}
                              </Name>
                            </ChatIDS>
                          );
                        }
                      })}
                    </ChatListContainer>
                  </Scrollbars>
                </ScrollableContainer>
              </ChatContent>
            </ChatBox>
            <MessageBox>{props.children}</MessageBox>
          </ChatBoxContainer>
        </div>
      </div>
    </div>
  );
};

export default Chat;

const Search = styled.div`
  paddingleft: 20px;
  display: flex;
`;
const NewMsgHeader = styled.div``;

const TextBox = styled.div`
  position: absolute;
  width: 35%;
  height: 500px;
  background-color: #0c343a;
  border-radius: 20px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  @media (max-width: 635px) {
    width: 50%;
    height: 500px;
  }
`;

const H2 = styled.h2`
  font-size: 20px;

  @media (max-width: 900px) {
    display: none;
  }
`;

const Name = styled.div`
  margin-left: 10px;
  display: flex;
  width: 150px;
  overflow: hidden;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 900px) {
    display: none;
  }
`;

const Header = styled.div`
  padding-left: 20px;
  display: flex;
  justify-content: space-between;
  color: white;

  @media (min-width: 350px) and (max-width: 900px) {
    align-items: center;
    justify-content: center;
    display: flex;
  }
`;

const IconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;

const PopoverContent = styled.div`
  position: absolute;
  top: 50px; /* Adjust as needed */
  right: 0;
  width: 50%; /* Makes the popover half the width of its parent */
  padding: 20px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 100; /* Ensures it appears above other content */
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
`;

const MessageHeading = styled.h3`
  margin: 20px 0 0 0;
  padding-left: 18px;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  flex-shrink: 0; /* Prevent shrinking */

  @media (min-width: 350px) and (max-width: 900px) {
    display: none;
  }
`;

const MessageHeadingIcon = styled.h3`
  margin: 20px 0 0 0;
  color: white;
  display: none;
  flex-shrink: 0; /* Prevent shrinking */

  @media (min-width: 350px) and (max-width: 900px) {
    display: block;
  }
`;

const ChatContent = styled.div`
  margin-top: 25px;
  padding: 0 10px;
  height: 100%;
  display: flex;
  flex-direction: column;

  /* Global scrollbar hiding for all elements in chat content */
  * {
    scrollbar-width: none !important; /* Firefox */
    -ms-overflow-style: none !important; /* IE and Edge */

    &::-webkit-scrollbar {
      display: none !important; /* Chrome, Safari, Opera */
      width: 0 !important;
      height: 0 !important;
    }

    &::-webkit-scrollbar-track {
      display: none !important;
    }

    &::-webkit-scrollbar-thumb {
      display: none !important;
    }

    &::-webkit-scrollbar-corner {
      display: none !important;
    }
  }

  @media (min-width: 350px) and (max-width: 900px) {
    align-items: center;
    justify-content: flex-start;
  }
`;

/* New styled component for the scrollable container */
const ScrollableContainer = styled.div`
  flex: 1;
  min-width: 100px;
  min-height: 0;
  margin-top: 15px;
  overflow-y: auto;

  /* Firefox */
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;

  /* Webkit */
  &::-webkit-scrollbar {
    width: 8px;
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 8px;
    transition: background 0.3s ease;
  }
  .custom-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.4); /* visible on hover */
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &:hover::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.4);
  }

  &:hover::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.2);
  }
`;

/* Container for the chat list items */
const ChatListContainer = styled.div`
  padding: 0 5px;

  /* Hide scrollbars for chat list */
  scrollbar-width: none !important;
  -ms-overflow-style: none !important;

  &::-webkit-scrollbar {
    display: none !important;
    width: 0 !important;
    height: 0 !important;
  }
`;

const ChatIDS = styled.div`
  width: 100%;
  height: 65px;
  display: flex;
  align-items: center;
  padding: 8px 10px;
  margin-bottom: 2px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #1a4a52;
    border-radius: 10px;
  }

  @media (min-width: 350px) and (max-width: 900px) {
    justify-content: center;
    padding: 8px;
  }
`;

const MessageBox = styled.div`
  flex: 1;
  width: 100%;
  height: 98%;

  /* Global scrollbar hiding for message box */
  * {
    scrollbar-width: none !important; /* Firefox */
    -ms-overflow-style: none !important; /* IE and Edge */

    &::-webkit-scrollbar {
      display: none !important; /* Chrome, Safari, Opera */
      width: 0 !important;
      height: 0 !important;
    }

    &::-webkit-scrollbar-track {
      display: none !important;
    }

    &::-webkit-scrollbar-thumb {
      display: none !important;
    }

    &::-webkit-scrollbar-corner {
      display: none !important;
    }
  }

  @media (min-width: 1700px) {
    height: 96%;
  }
`;

const ChatBox = styled.div`
  height: 98%;
  background-color: #0c343a;
  width: 300px;
  border: 1px solid white;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  position: sticky;
  display: flex;
  flex-direction: column;

  /* Global scrollbar hiding for chat box */
  * {
    scrollbar-width: none !important; /* Firefox */
    -ms-overflow-style: none !important; /* IE and Edge */

    &::-webkit-scrollbar {
      display: none !important; /* Chrome, Safari, Opera */
      width: 0 !important;
      height: 0 !important;
    }

    &::-webkit-scrollbar-track {
      display: none !important;
    }

    &::-webkit-scrollbar-thumb {
      display: none !important;
    }

    &::-webkit-scrollbar-corner {
      display: none !important;
    }
  }

  @media (min-width: 350px) and (max-width: 900px) {
    width: 75px;
  }
`;

const ChatBoxContainer = styled.div`
  width: 100%;
  max-width: 1400px;
  height: 100%;
  display: flex;

  /* Global scrollbar hiding for entire container */
  * {
    scrollbar-width: none !important; /* Firefox */
    -ms-overflow-style: none !important; /* IE and Edge */

    &::-webkit-scrollbar {
      display: none !important; /* Chrome, Safari, Opera */
      width: 0 !important;
      height: 0 !important;
    }

    &::-webkit-scrollbar-track {
      display: none !important;
    }

    &::-webkit-scrollbar-thumb {
      display: none !important;
    }

    &::-webkit-scrollbar-corner {
      display: none !important;
    }
  }
`;
